Pegasus.HistoryOperationsController = Em.ObjectController.extend({
  actions: {
    didExecute: function(){},
    didUnexecute: function(){}
  },
  shouldShow: true,
  cherryPick: function(command) {}
});
